export default ({ action, event, ...data }) => typeof window !== "undefined" && window.gtag && window.gtag("event", event, { ...data });